import { Typography } from "@mui/material";
import { RTFOPumpdownChart } from "./RTFOPumpdownChart";
import { RTFOStageIsolationDataTable } from "./RTFOStageIsolationDataTable";

const RTFOStageSummary = ({ 
  currentRTFO,
  gridView, 
  showSpikeLines, 
  pumpdownData,
  pumpdownFalloffTimestamps,
  setPumpdownFalloffTimestamps,
  pressureTestTimestamps,
  setPressureTestTimestamps,
  postPlugFalloffTimestamps,
  setPostPlugFalloffTimestamps,
  postPerfFalloffTimestamps,
  setPostPerfFalloffTimestamps,
  customTimestamps,
  setCustomTimestamps,
  isLoadingPumpdownData,
  editMode,
  pumpdownRegression,
  setPumpdownRegression,
  pumpdownRegressionStartTimestamp,
  initialRegression,
  initialRegressionStartTimestamp,
  postPerfRegressionStartTimestamp,
  darkMode,
  userEmail
}) => {
  return (
    <div>

      <div style={{width: 'calc(100% - 20px)', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '20px 20px 0px 20px'}}>
        <Typography variant="h6">
          Stage Summary
        </Typography>
      </div>

      <div style={{height: 600, padding: 2}}>
        <RTFOPumpdownChart 
          gridView={gridView} 
          showSpikeLines={true} 
          pumpdownData={pumpdownData}
          pumpdownFalloffTimestamps={pumpdownFalloffTimestamps}
          setPumpdownFalloffTimestamps={setPumpdownFalloffTimestamps}
          pressureTestTimestamps={pressureTestTimestamps}
          setPressureTestTimestamps={setPressureTestTimestamps}
          postPlugFalloffTimestamps={postPlugFalloffTimestamps}
          setPostPlugFalloffTimestamps={setPostPlugFalloffTimestamps}
          postPerfFalloffTimestamps={postPerfFalloffTimestamps}
          setPostPerfFalloffTimestamps={setPostPerfFalloffTimestamps}
          customTimestamps={customTimestamps}
          setCustomTimestamps={setCustomTimestamps}
          isLoadingPumpdownData={isLoadingPumpdownData}
          editMode={editMode}
          pumpdownRegression={pumpdownRegression}
          setPumpdownRegression={setPumpdownRegression}
          pumpdownRegressionStartTimestamp={pumpdownRegressionStartTimestamp}
          initialRegression={initialRegression}
          initialRegressionStartTimestamp={initialRegressionStartTimestamp}
          postPerfRegressionStartTimestamp={postPerfRegressionStartTimestamp}
        />
      </div>

      <Typography variant="h6" style={{marginLeft: 20, marginTop: 20}}>Stage Isolation Summary</Typography>
      <div style={{width: '100%', height: 800, padding: 0}}>
        <RTFOStageIsolationDataTable currentRTFO={currentRTFO} darkMode={darkMode} userEmail={userEmail} />
      </div>

    </div>
  );
};

export default RTFOStageSummary;